import {auth, fn} from '../firebase'

export default class General {

  static debounce(func, wait, immediate) {
    var timeout

    return function () {
      var context = this, args = arguments
      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  }

  static signInAsAdmin(uid) {
    var tokenFn = fn.httpsCallable('mintAdminToken');
    tokenFn({ uid: uid}).then(function (res) {
      return auth.signInWithCustomToken(res.data.token);
    });
  }
}